module.exports = __webpack_public_path__ + "static/media/worldfavor_logo_white.c388bb02.svg";